module.exports = __webpack_public_path__ + "assets/DoubleAngleDetailed.073a6075b30cd2a7dc8841c82232fffd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/DoubleAngleDetailed.png
// module id = 502
// module chunks = 0